// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chip_wrapper__CFETk","text":"Chip_text__Bfmvn","delete":"Chip_delete__JSHvx"};